class MCartRemoveButton extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("click", (t) => {
        t.preventDefault();
        (
          this.closest("m-cart") || this.closest("m-cart-drawer-items")
        ).updateQuantity(this.dataset.index, 0);
      });
  }
}
customElements.define("m-cart-remove-button", MCartRemoveButton);
class MCartTemplate extends HTMLElement {
  constructor() {
    super(),
      (this.cartUpdateUnsubscriber = void 0),
      (this.isCartPage = "cart" === MinimogSettings.templateName),
      (this.cartDrawerWrapper = document.querySelector("m-cart-drawer")),
      (this.cartDrawerInner = document.querySelector(".m-cart-drawer__inner")),
      (this.mainCartItems = this.querySelector("[data-minimog-cart-items]")),
      (this.cartSubTotal = this.querySelector("[data-cart-subtotal]")),
      (this.cartDiscount = this.querySelector("[data-minimog-cart-discounts]")),
      (this.giftWrapping = this.querySelector("[data-minimog-gift-wrapping]"));
    let t = this.cartDrawerInner;
    this.isCartPage && (t = document.body),
      (this.loading = new MinimogLibs.AnimateLoading(t, { overlay: t })),
      (this.rootUrl = window.Shopify.routes.root);
    const e = debounce((t) => {
      "id" !== t.target.name && this.onChange(t);
    }, 300);
    this.isCartPage
      ? this.mainCartItems.addEventListener("change", e.bind(this))
      : this.addEventListener("change", e.bind(this)),
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (t) => {
        this.getCart().then((t) => {
          this.updateCartCount(t.item_count);
          checkPreorder(t)
        });
      });
     fetchJSON(window.Shopify.routes.root + "cart.json").then(
      (e) => {
        if (e) {
          this.UpdateProgressBar(e)
        }
      }
    );
  }
  updateCartCount(t) {
    document.querySelectorAll(".m-cart-count-bubble").forEach((e) => {
      t > 0
        ? ((e.textContent = t), e.classList.remove("m:hidden"))
        : e.classList.add("m:hidden");
    });
  }
  getCart() {
    return fetchJSON(this.rootUrl + "cart.json");
  }
  connectedCallback() {
    this.cartUpdateUnsubscriber = MinimogEvents.subscribe(
      MinimogTheme.pubSubEvents.cartUpdate,
      (t) => {
        "main-cart-items" !== t.source && this.onCartUpdate();
      }
    );
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onCartUpdate(t = !0) {
    const { routes: e } = window.MinimogSettings;
    fetch(`${e.cart}?section_id=cart-template`)
      .then((t) => t.text())
      .then((e) => {
        const i = new DOMParser().parseFromString(e, "text/html"),
          n = i.querySelector("[data-minimog-cart-items]"),
          r = i.querySelector("[data-cart-subtotal]"),
          a = i.querySelector("[data-minimog-cart-discounts]"),
          s = i.querySelector("[data-minimog-gift-wrapping]");
        this.isCartPage &&
          ((this.mainCartItems.innerHTML = n.innerHTML),
          t &&
            ((this.cartSubTotal.innerHTML = r.innerHTML),
            (this.cartDiscount.innerHTML = a.innerHTML),
            (this.giftWrapping.innerHTML = s.innerHTML)));
      })
      .catch((t) => {});
  }
  onChange(t) {
    this.updateQuantity(
      t.target.dataset.index,
      t.target.value,
      document.activeElement.getAttribute("name")
    );
  }
  updateQuantity(t, e, i) {
    this.loading.start();
    const { routes: n } = window.MinimogSettings,
      r = JSON.stringify({
        line: t,
        quantity: e,
        sections: this.getSectionsToRender().map((t) => t.section),
        sections_url: window.location.pathname,
      });
    fetch(`${n.cart_change_url}`, { ...fetchConfig(), body: r })
      .then((t) => t.text())
      .then((e) => {
        const i = JSON.parse(e);
        let n = document.getElementById(`MinimogDrawer-quantity-${t}`);
        this.isCartPage &&
          (n = MinimogTheme.config.mqlMobile
            ? document.querySelector(
                `.MinimogQuantity-${t}.MinimogQuantity-mobile`
              )
            : document.querySelector(
                `.MinimogQuantity-${t}.MinimogQuantity-desktop`
              ));
        const r = document.querySelectorAll(".m-cart-item");
        if (i.errors)
          return (
            this.loading.finish(),
            (n.value = n.getAttribute("value")),
            void this.updateLiveRegions(t, i.errors)
          );
        this.classList.toggle("m-cart--empty", 0 === i.item_count),
          this.cartDrawerWrapper &&
            this.cartDrawerWrapper.classList.toggle(
              "m-cart--empty",
              0 === i.item_count
            );
          this.UpdateProgressBar(i);
          this.FreeProduct(i);
          this.removeFreeProduct()
          this.getSectionsToRender().forEach((t) => {
            (
              document.getElementById(t.id).querySelector(t.selector) ||
              document.getElementById(t.id)
            ).innerHTML = this.getSectionInnerHTML(
              i.sections[t.section],
              t.selector
            );
          });
        const a = i.items[t - 1] ? i.items[t - 1].quantity : void 0;
        let s = "";
        r.length === i.items.length &&
          a !== parseInt(n.value) &&
          (s =
            void 0 === a
              ? window.MinimogStrings.cartError
              : window.MinimogStrings.quantityError.replace(
                  "{{ quantity }}",
                  a
                )),
          this.updateLiveRegions(t, s),
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
            ...i,
            source: "main-cart-items",
          });

      })
      .catch(() => {})
      .finally(() => {
        this.loading.finish();
      });
  }
  updateLiveRegions(t, e) {
    let i = document.getElementById(`MinimogCartDrawer-Item-${t}`);
    this.isCartPage && (i = document.getElementById(`MinimogCart-Item-${t}`)),
      "" !== e &&
        i &&
        MinimogTheme.Notification.show({
          target: i,
          type: "warning",
          message: e,
        });
  }
  getSectionInnerHTML(t, e) {
    return new DOMParser().parseFromString(t, "text/html").querySelector(e)
      .innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[data-minimog-cart-items]",
      },
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[data-cart-subtotal]",
      },
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[data-minimog-cart-discounts]",
      },
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[data-minimog-gift-wrapping]",
      },
    ];
  }
  
  FreeProduct(cart){
      var selfThis = this;
      var Items = cart.items,
          UnlockedItemId,
          UnlockedItem = [],
          ExfreeItem = [],
          Arrayupdate = [],
          NeedtoRemove = [],
          NeedtoAdd = [],
          Rp = { updates: {} },
          Needtoupdate = false,
          Product1 = parseInt($('#freeProduct').val()),
          Product2 = parseInt($('#secondFreeProduct').val()),
          firstprice = window.free_gift_rate * Number(Shopify.currency.rate),
          secondGiftprice = window.second_free_gift_rate * Number(Shopify.currency.rate);

      console.log(Product1,'ab',firstprice);
    
      if(!Product1 && isNaN(Product1)){
        return
      }
    
      if(secondGiftprice && cart.total_price >= secondGiftprice){
        UnlockedItem.push(Product1);
        UnlockedItem.push(Product2);
      }else if(firstprice && cart.total_price >= firstprice){
        UnlockedItem.push(Product1);
      }
    
      for(let i=0; i < Items.length;i++){
        var Item = Items[i];
        if(Item.id == Product1 || Item.id == Product2 ){
          if (Item.properties['_free-product']) {
            ExfreeItem.push(Item.id);
          }
        }
      }

      for(let j=0; j < ExfreeItem.length; j++){
        var Ex = ExfreeItem[j];
        console.log('1');
        if(jQuery.inArray(Ex,UnlockedItem) == -1){
          console.log('2');
          Needtoupdate = true;
          NeedtoRemove.push(Ex);
          Rp.updates[Ex] = 0;
        }
      }
    
      for(let k=0; k < UnlockedItem.length; k++){
        var Fr = UnlockedItem[k];
        if(jQuery.inArray(Fr,ExfreeItem) == -1){
          Needtoupdate = true;
          NeedtoAdd.push(Fr);
        }
      }
    
      if(Needtoupdate){
        if(NeedtoRemove.length){
          jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: Rp,
            dataType: 'json',
            success: function(res) {
              if(NeedtoAdd.length){
                selfThis.freeProductAddToCart(NeedtoAdd);
              } else{
                selfThis.refreshCart();
              }
            }
          });
        }else if(NeedtoAdd.length){
          selfThis.freeProductAddToCart(NeedtoAdd);
        }
      }

      fetch('/cart.js').then(res => res.json()).then((cart) => {
        window.cart = cart;
        var ForceUpdate = { updates: {} },
            Items = cart.items,
            ForceUpdatestatus = false;
        for(let m=0; m < Items.length; m++){
          var Item = Items[m];
          if(Item.id == Product1 || Item.id == Product2){
            if(Item.quantity > 1){
              ForceUpdate.updates[Item.id] = 1;
              ForceUpdatestatus = true;
            }
          }
          if (Item.properties_all && Item.properties_all['_free-product'] || Item.properties && Item.properties['_free-product']) {
            if(Item.id != Product1 && Item.id != Product2){
              ForceUpdate.updates[Item.id] = 0;
              ForceUpdatestatus = true;
            }
          }
        }
        if(ForceUpdatestatus){
          jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: ForceUpdate,
            dataType: 'json',
            success: function(res) {
              selfThis.refreshCart();
            }
          });
        }
      });
      
    }
  
    freeProductAddToCart(Products) {
      console.log(Products,'Products');
      if(Products.length){
        let formData = { 'items': [] };
        for(let i=0; i < Products.length; i++){
          if(Products[i]){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-product':'true'} })
          }
        }
        if(formData.items.length){
          var selfThis = this;
          fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
             selfThis.refreshCart();
             selfThis.freeProductAnimation();
          }).catch((error) => {
            selfThis.refreshCart();  
          });
        }
      } 
    }

    refreshCart() {  
        var cartd = document.querySelector('m-cart-drawer');
        if(cartd) {
          cartd.onCartDrawerUpdate(false);
          fetchJSON(window.Shopify.routes.root + "cart.json").then(
            (e) => {
              if (e) {
                this.UpdateProgressBar(e);
                this.removeFreeProduct();
              }
            }
          )
        } else {
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {});
          this.removeFreeProduct();
        }
    }
  
    freeProductAnimation() {
      const titleElement = document.querySelector('#cartdrawer-progress-bar');
      const rect = titleElement.getBoundingClientRect();
    
      confetti({
        particleCount: 150,
        spread: 70,
        startVelocity: 30, // Increase the initial speed of the particles
        decay: 0.9, // Decrease the decay to slow down the rate at which particles lose speed
        colors: ['#DABBD5', '#CEC36A'], 
        origin: { 
          x: (rect.left + rect.width / 2) / window.innerWidth,
          y: (rect.top + rect.height / 2) / window.innerHeight 
        }
      });
    }

    UpdateProgressBar(cart) {
      var progressBar = $('#cartdrawer-progress-bar');
      if(progressBar.length != 0){
          var Items = cart.items;
          var cartTotalPrice = cart.total_price;
        
          if(cartTotalPrice > 0){
            $("#cartdrawer-progress-bar").addClass('active');
          }else{
            $("#cartdrawer-progress-bar").removeClass('active');
          }
          
          var firstFreeProduct = parseFloat(
              $(".cartdrawer-progress-bar").attr("data-firstproduct") * Number(Shopify.currency.rate)
            ),
            secondFreeProduct = parseFloat(
              $(".cartdrawer-progress-bar").attr("data-secondproduct") * Number(Shopify.currency.rate)
            ),
            freeShipping = parseFloat(
              $(".cartdrawer-progress-bar").attr("data-freeShipping") * Number(Shopify.currency.rate)
            );

          
          if(firstFreeProduct != 0 || secondFreeProduct != 0){
            var highestThreshold = Math.max(freeShipping, firstFreeProduct, secondFreeProduct);
            var combinedPercentage = (cartTotalPrice * 95) / highestThreshold;
            
            var freeShippingPr = (freeShipping * 95) / highestThreshold;
            var firstProductPr = (firstFreeProduct * 95) / highestThreshold;
            var secondProductPr = (secondFreeProduct * 95) / highestThreshold;
          }

          if(firstFreeProduct == 0 && secondFreeProduct == 0){
            var freeShippingPr = 95;
            var combinedPercentage = (cartTotalPrice * 95) / freeShipping;
          }
        
        
          if (combinedPercentage > 100) {
            var combinedPercentage = 100;
          }
        
          console.log(combinedPercentage,'combinedPercentage');
        
          $("#cartdrawer-progress-bar")
            .find(".threshold-bar-progress-inner")
            .css("width", combinedPercentage + "%");
          $("#cartdrawer-progress-bar")
            .find(".threshold-bar-indicator.zero")
            .css("left", freeShippingPr + "%");
          $("#cartdrawer-progress-bar")
            .find(".threshold-bar-indicator.first")
            .css("left", firstProductPr + "%");
          $("#cartdrawer-progress-bar")
            .find(".threshold-bar-indicator.second")
            .css("left", secondProductPr + "%");
        
          if(cartTotalPrice >= freeShipping){
            $("#cartdrawer-progress-bar")
              .find(".threshold-bar-indicator.zero")
              .addClass("active");
          }else{
            $("#cartdrawer-progress-bar")
              .find(".threshold-bar-indicator.zero")
              .removeClass("active");
          }
          
          if (cartTotalPrice >= firstFreeProduct) {
            $("#cartdrawer-progress-bar")
              .find(".threshold-bar-indicator.first")
              .addClass("active");
          } else {
            $("#cartdrawer-progress-bar")
              .find(".threshold-bar-indicator.first")
              .removeClass("active");
          }
    
          if (cartTotalPrice >= secondFreeProduct) {
            $("#cartdrawer-progress-bar")
              .find(".threshold-bar-indicator.second")
              .addClass("active");
          } else {
            $("#cartdrawer-progress-bar")
              .find(".threshold-bar-indicator.second")
              .removeClass("active");
          }
        
          var nextTarget = false,
              targetOffer = "",
              successMessage = $('#cartdrawer-progress-bar').attr('data-success-message'),
              progressMessage = $('#cartdrawer-progress-bar').attr('data-progress-message'),
              messageParts = progressMessage.split('{{amount}}'),
              firstHalfMessage = messageParts[0],
              secondHalfMessage = messageParts[1].replace('{{target}}', ''),
              firstBreakPoint = $('#cartdrawer-progress-bar').attr('data-shipping-breakpoint'),
              secondGiftBreakPoint = $('#cartdrawer-progress-bar').attr('data-firstgift-breakpoint'),
              thirdGiftBreakPoint = $('#cartdrawer-progress-bar').attr('data-second-breakpoint');
    

          const highestsThreshold = Math.max(freeShipping, firstFreeProduct, secondFreeProduct);
          const lowestThreshold = Math.min(freeShipping, firstFreeProduct, secondFreeProduct);
          const thresholdsArray = [freeShipping, firstFreeProduct, secondFreeProduct];
          
          let second_Threshold = 0;
          for (let i = 0; i < thresholdsArray.length; i++) {
            const thresholdNumber = thresholdsArray[i];
            if (thresholdNumber < highestThreshold && thresholdNumber > lowestThreshold) {
              second_Threshold = thresholdNumber;
            }
          }

          if(firstFreeProduct != 0 && secondFreeProduct != 0){
            if (cartTotalPrice < lowestThreshold) {
              nextTarget = lowestThreshold;
              targetOffer = firstBreakPoint;
            } else if (cartTotalPrice < second_Threshold) {
              nextTarget = second_Threshold;
              targetOffer = secondGiftBreakPoint;
            } else if (cartTotalPrice < highestsThreshold) {
              nextTarget = highestsThreshold;
              targetOffer = thirdGiftBreakPoint;
            } else {
              targetOffer = "";
            }
          }else if(firstFreeProduct != 0 || secondFreeProduct != 0){
            if(freeShipping != 0){
              if (cartTotalPrice < lowestThreshold) {
                nextTarget = lowestThreshold;
              } else if (cartTotalPrice < second_Threshold) {
                nextTarget = second_Threshold;
                targetOffer = firstBreakPoint;
              } else if (cartTotalPrice < highestsThreshold) {
                nextTarget = highestsThreshold;
                targetOffer = secondGiftBreakPoint;
              } 
            }else{
              if (cartTotalPrice < highestsThreshold) {
                nextTarget = highestsThreshold;
                targetOffer = firstBreakPoint;
              }
            }
          }else{
             console.log(cartTotalPrice,'4',highestsThreshold,firstBreakPoint);
            if (cartTotalPrice < highestsThreshold) {
              nextTarget = highestsThreshold;
              targetOffer = firstBreakPoint;
            }
          }

          console.log(targetOffer,'targetOffer');
        
          if (targetOffer) {
            var remainingAmount = nextTarget - cartTotalPrice;
            let config = document.getElementById("cart-config");
            $(".progress-bar-messages").html(
              '<div class="progress-messages messages">'+firstHalfMessage+'<span class="remaining-amount">' +
                formatMoney(remainingAmount,MinimogSettings.money_format) +
                '</span>'+secondHalfMessage+'<span class="next-progress-name"> ' +
                targetOffer +
                "</span>.</div>"
            );
          } else {
            targetOffer = "";
            $(".progress-bar-messages").html(
              '<div class="complete-messages messages">'+successMessage+'</div>'
            );
          }
        }
      }
  
      removeFreeProduct() {
        var Product1 = parseInt($('#freeProduct').val()),
            Product2 = parseInt($('#secondFreeProduct').val()),
            firstprice = window.free_gift_rate * Number(Shopify.currency.rate),
            secondGiftprice = window.second_free_gift_rate * Number(Shopify.currency.rate),
            selfThis = this;
    
      
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                var cartTotal = cart.total_price; 
    
                var changes = {};
                
                if (cartTotal < firstprice) {
                    var lineItem1 = cart.items.find(item => item.id === Product1);
                    if (lineItem1) {
                        changes[lineItem1.key] = 0;
                    }
                }
    
                if (cartTotal < secondGiftprice) {
                    var lineItem2 = cart.items.find(item => item.id === Product2);
                    if (lineItem2) {
                        changes[lineItem2.key] = 0;
                    }
                }
    
                if (Object.keys(changes).length > 0) {
                    fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            updates: changes
                        })
                    })
                    .then(response => response.json())
                    .then(data => {
                        var cartd = document.querySelector('m-cart-drawer');
                        if(cartd) {
                          cartd.onCartDrawerUpdate(false);
                          fetchJSON(window.Shopify.routes.root + "cart.json").then(
                            (e) => {
                              if (e) {
                                selfThis.UpdateProgressBar(e);
                              }
                            }
                          )
                        } else {
                          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {});
                        }
                    })
                    .catch(error => {
                    });
                }
            })
            .catch(error => {
            });
      }
}
customElements.define("m-cart", MCartTemplate);


// Check Preorder
fetchJSON(window.Shopify.routes.root + "cart.json").then(
  (cart) => {
   checkPreorder(cart)
  }
);

// Add the event listener to the button
const preorderButton = document.querySelector('.custom-element');

if (preorderButton) {
    preorderButton.addEventListener('click', function(e) {
      const preorderCheckbox = document.getElementById('preorder');
      
      if (preorderCheckbox && document.querySelector('.form-preorder').style.display != "none") {
          if (!preorderCheckbox.checked) {
              e.preventDefault(); 
              const alertMessage = document.querySelector('.form-preorder').getAttribute('data-alert');
              document.querySelector('.form-preorder label').classList.add('error-text');
              alert(alertMessage);
          } 
      }
  });
}

function checkPreorder(cart) {
    const hasPreorderItem = cart.items.some(item => /\bpreorder\b/i.test(item.title));
    const formPreorder = document.querySelector('.form-preorder');
    const preorderCheckbox = document.getElementById('preorder');
    
    if (formPreorder) {
      formPreorder.style.display = hasPreorderItem ? 'block' : 'none'; 
    }
    if (preorderCheckbox && document.querySelector('.form-preorder').style.display != "none") {
      $('.with-preorder-submit').hide();
      $('.custom-element').show(); 
    } else {
      $('.with-preorder-submit').show();
      $('.custom-element').hide();
    }
}


const checkbox = document.getElementById('preorder');
if (checkbox) {
    checkbox.addEventListener('change', function() {
        if(checkbox.checked) {
          document.querySelector('.form-preorder label').classList.remove('error-text');
          $('.with-preorder-submit').show();
          $('.custom-element').hide();
        }else {
         $('.with-preorder-submit').hide();
         $('.custom-element').show(); 
        }
    });
}




